import analytics from 'scenes/common/analytics';
import { ApiErrorReasonType } from 'scenes/common/types';
import { LandlordFunnelState, ReferenceData } from 'scenes/landlord/types';
import { getQuoteNumber } from '../selectors';

import {
  marshalCallUsEvent,
  marshalEmailQuoteEvent,
  marshalQuoteDeclined,
  marshalQuoteReferred,
  marshalResumeQuoteEvent,
  marshalRetrieveQuoteCompleteEvent,
  marshalSaveQuoteEvent,
  marshalViewLoadedEvent,
} from './marshaller';

const landlordAnalytics = () => ({
  viewLoaded: (
    funnelState: LandlordFunnelState,
    referenceData: ReferenceData
  ) => {
    analytics().pushEvent(marshalViewLoadedEvent(funnelState, referenceData));
  },
  callUs: (funnelState: LandlordFunnelState) => {
    analytics().pushEvent(marshalCallUsEvent(funnelState));
  },
  saveQuote: (funnelState: LandlordFunnelState) => {
    analytics().pushEvent(marshalSaveQuoteEvent(funnelState));
  },
  emailQuote: (funnelState: LandlordFunnelState) => {
    analytics().pushEvent(marshalEmailQuoteEvent(funnelState));
  },
  resumeQuote: (funnelState: LandlordFunnelState) => {
    analytics().pushEvent(marshalResumeQuoteEvent(funnelState));
  },
  retrieveQuoteComplete: (funnelState: LandlordFunnelState) => {
    analytics().pushEvent(marshalRetrieveQuoteCompleteEvent(funnelState));
  },
  referral: (
    funnelState: LandlordFunnelState,
    errorReason: ApiErrorReasonType,
    referenceData: ReferenceData
  ) => {
    if (errorReason === ApiErrorReasonType.Referral) {
      analytics().pushEvent(
        marshalQuoteReferred(
          funnelState,
          getQuoteNumber(funnelState),
          referenceData.buildingTypes
        )
      );
    } else if (errorReason === ApiErrorReasonType.Declined) {
      analytics().pushEvent(
        marshalQuoteDeclined(
          funnelState,
          getQuoteNumber(funnelState),
          referenceData.buildingTypes
        )
      );
    }
  },
});

export default landlordAnalytics;
